module.exports = __webpack_public_path__ + "static/media/Thumbnail_2.4d9dd4de.png";